import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const phoneExtItemService = {
    getAll,
    store,
    show,
    update,
    updateStatus,
    updateSequence,
};

const MODULE = {
    PHONE_EXT_ITEM: 'phone-ext-items',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            phone_ext_department_uuid: filter?.phoneExtDepartmentUuid,
            is_active: filter?.isActive,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.PHONE_EXT_ITEM}`, request);
}

export function store (data) {
    const request = {
        phone_ext_department_uuid: data.phoneExtDepartmentUuid,
        user_uuid: data.userUuid,
        name: data.name,
        email: data.email,
        phone_code: data.phoneCode,
        phone_number: data.phoneNumber,
        phone_iso: data.phoneIso,
        ext: data.ext,
        did_call: data.didCall,
        sequence: data.sequence,
    };

    return apiHelper(API_URL).post(`/${MODULE.PHONE_EXT_ITEM}`, request);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.PHONE_EXT_ITEM}/${uuid}`);
}

export function update (data) {
    const request = {
        phone_ext_department_uuid: data.phoneExtDepartmentUuid,
        user_uuid: data.userUuid,
        name: data.name,
        email: data.email,
        phone_code: data.phoneCode,
        phone_number: data.phoneNumber,
        phone_iso: data.phoneIso,
        ext: data.ext,
        did_call: data.didCall,
        sequence: data.sequence,
    };

    return apiHelper(API_URL).put(`/${MODULE.PHONE_EXT_ITEM}/${data.uuid}`, request);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.PHONE_EXT_ITEM}/${data.uuid}`, request);
}

export function updateSequence (data) {
    const request = {
        phone_ext_department_uuid: data.phoneExtDepartmentUuid,
        items: (data.items ?? []).map(item => ({
            uuid: item.uuid,
            sequence: item.sequence,
        })),
    };

    return apiHelper(API_URL).patch(`/${MODULE.PHONE_EXT_ITEM}/sequences`, request);
}
